/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Glossary_DescriptionInputs */



/**
* | output |
* | --- |
* | "Symbols, keywords, and shorthand" |
*
* @param {Nav_Glossary_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_glossary_description = /** @type {((inputs?: Nav_Glossary_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Glossary_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Symbole, Schlüsselwörter und Kurzformen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Symboles, mots-clés et abréviations")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("符号、关键词与简写")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("符號、關鍵字與縮寫")
	if (locale === "ko") return /** @type {LocalizedString} */ ("기호, 키워드, 약어")
	return /** @type {LocalizedString} */ ("Symbols, keywords, and shorthand")
});